import { onSnapshot } from 'firebase/firestore';
import { useMemo, useState, useEffect } from 'react';
import { BidDocument } from '@models/bid';
import { getBidsByProductIdQuery } from '@util/firestore/bid';

const useRealTimeBids = (productId: string, uid?: string) => {
  const [realTimeBids, setBids] = useState<BidDocument[]>([]);
  const bidsQuery = useMemo(
    () => (productId ? getBidsByProductIdQuery(productId) : null),
    [productId]
  );

  const highestBid = useMemo(() => {
    return realTimeBids.sort((a, b) => b.bid_price - a.bid_price)[0];
  }, [realTimeBids]);

  const usersBids = useMemo(() => {
    return realTimeBids.filter((bid) => uid && bid.uid === uid);
  }, [realTimeBids, uid]);

  useEffect(() => {
    if (!bidsQuery) return;
    const unsubscribe = onSnapshot(bidsQuery, (snapshot) => {
      const realTimeData = snapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      setBids(realTimeData);
    });
    return () => {
      unsubscribe();
    };
  }, [bidsQuery]);

  return {
    highestBid,
    usersBids,
    realTimeBids,
  };
};

export default useRealTimeBids;
